import React, { useState } from 'react';
import { SparklesIcon } from 'lucide-react';
type PlanType = 'inicial' | 'mentoria';
export function EarlyOfferSection() {
  const [selectedPlan, setSelectedPlan] = useState<PlanType>('mentoria');
  return <section className="px-4 py-8 pl-[16px] pr-[16px]" data-id="element-59">
      <div className="max-w-[720px] mx-auto" data-id="element-60">
        <h2 className="mb-6 text-2xl font-bold text-center md:text-3xl text-white font-sans" data-id="element-61">
          Elegí tu <span className="text-violet-500" data-id="element-62">MegaPack Tarot</span> 🔮
        </h2>
        <div className="flex flex-col gap-4 mb-6" data-id="element-63">
          {/* Card 1 - Inicial */}
          <div onClick={() => setSelectedPlan('inicial')} className={`relative p-5 md:p-6 rounded-2xl cursor-pointer transition-all duration-300 border ${selectedPlan === 'inicial' ? 'bg-[#1a1a1c] border-brand-teal/50 shadow-[0_0_15px_rgba(168,85,247,0.1)]' : 'bg-[#141415] border-white/5 hover:border-white/10 hover:bg-[#1a1a1c]'}`} data-id="element-64">
            <div className="flex items-start gap-4" data-id="element-65">
              <div className="flex-shrink-0 mt-1" data-id="element-66">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPlan === 'inicial' ? 'border-brand-teal' : 'border-white/20'}`} data-id="element-67">
                  {selectedPlan === 'inicial' && <div className="w-3 h-3 rounded-full bg-brand-teal" data-id="element-68" />}
                </div>
              </div>

              <div className="flex-1" data-id="element-69">
                <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-2 mb-1" data-id="element-70">
                  <div data-id="element-71">
                    <h3 className="text-lg font-bold text-white font-sans" data-id="element-72">
                      MEGAPACK TAROT INICIAL
                    </h3>
                    <p className="text-sm text-brand-dark/60 mt-1 font-sans" data-id="element-73">
                      Acceso al megapack base + bonos
                    </p>
                  </div>
                  <div className="text-left md:text-right" data-id="element-74">
                    <div className="text-sm text-brand-dark/40 line-through font-sans" data-id="element-75">
                      $34.990
                    </div>
                    <div className="text-2xl font-bold text-white font-sans" data-id="element-76">
                      $19.990
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2 - Mentoría */}
          <div onClick={() => setSelectedPlan('mentoria')} className={`relative p-5 md:p-6 rounded-2xl cursor-pointer transition-all duration-300 border-2 ${selectedPlan === 'mentoria' ? 'bg-brand-tealLight/40 border-brand-teal shadow-[0_0_25px_rgba(168,85,247,0.2)]' : 'bg-[#141415] border-white/5 hover:border-white/10 hover:bg-[#1a1a1c]'}`} data-id="element-77">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-78">
              <span className="px-3 py-1 text-[10px] md:text-xs font-bold uppercase tracking-wider text-white bg-gradient-to-r from-brand-teal to-brand-amber rounded-full shadow-lg flex items-center gap-1 whitespace-nowrap" data-id="element-79">
                <SparklesIcon className="w-3 h-3" data-id="element-80" />
                MÁS ELEGIDO
              </span>
              <span className="px-3 py-1 text-[10px] md:text-xs font-bold uppercase tracking-wider text-brand-teal bg-brand-teal/10 border border-brand-teal/30 rounded-full whitespace-nowrap hidden sm:inline-block" data-id="element-81">
                AHORRÁS $16.000
              </span>
            </div>

            <div className="flex items-start gap-4 mt-2" data-id="element-82">
              <div className="flex-shrink-0 mt-1" data-id="element-83">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPlan === 'mentoria' ? 'border-brand-teal' : 'border-white/20'}`} data-id="element-84">
                  {selectedPlan === 'mentoria' && <div className="w-3 h-3 rounded-full bg-brand-teal" data-id="element-85" />}
                </div>
              </div>

              <div className="flex-1" data-id="element-86">
                <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-2 mb-2" data-id="element-87">
                  <div className="pr-0 md:pr-4" data-id="element-88">
                    <h3 className="text-lg font-bold text-white font-sans" data-id="element-89">
                      MEGAPACK TAROT INICIAL + MENTORÍA TAROT PRO™
                    </h3>
                    <span className="px-2 py-0.5 mt-2 text-[10px] font-bold uppercase tracking-wider text-brand-teal bg-brand-teal/10 border border-brand-teal/30 rounded-full inline-block sm:hidden mb-1" data-id="element-90">
                      AHORRÁS $16.000
                    </span>
                    <p className="text-sm text-brand-dark/70 mt-1 font-sans leading-relaxed" data-id="element-91">
                      Incluye el megapack inicial + mentoría para aplicar,
                      vender y profesionalizar tu servicio
                    </p>
                  </div>
                  <div className="text-left md:text-right flex-shrink-0" data-id="element-92">
                    <div className="text-sm text-brand-dark/40 line-through font-sans" data-id="element-93">
                      $43.990
                    </div>
                    <div className="text-3xl font-bold text-brand-teal font-sans" data-id="element-94">
                      $27.990
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center" data-id="element-95">
          <a href="#oferta" className="w-full py-5 px-6 text-base md:text-lg font-bold text-white text-center transition-all duration-300 bg-gradient-to-r from-brand-teal to-brand-amber rounded-xl hover:shadow-[0_0_30px_rgba(168,85,247,0.4)] hover:-translate-y-1 font-sans" data-id="element-96">
            {selectedPlan === 'mentoria' ? '→ SÍ, QUIERO EL MEGAPACK + MENTORÍA TAROT PRO™' : 'Quiero el MegaPack 🔮'}
          </a>
        </div>
      </div>
    </section>;
}